import React from "react";
import "../pages/style/carrieres.css";
import MapAddresse from "../home/mapAdresse" 
import NewsLetter from "../home/newsLetter"
import Footer from "../home/footer"
import SideList from "./../home/SideList";
import Popup from "reactjs-popup";
import BurgerIcon from "../home/BurgerIcon";
import Menu from "../home/Menu";
//import Postuler from "./Postuler";
import send from "../assets/carriere/send.svg";
import { Grid, Row, Col } from "react-flexbox-grid";
import ReactSVG from 'react-svg';
import logo_chifco from "../assets/carriere/logo_chifco.png";
import object_background from "../assets/carriere/object_background.png";
import Button from '@material-ui/core/Button';

import calendar from "../assets/carriere/calendar.svg";
import map from "../assets/carriere/map.svg";
import temps from "../assets/carriere/temps.svg";

import facebook from "../assets/carriere/share/facebook.svg";
import twitter from "../assets/carriere/share/twitter.svg";
import linkedin from "../assets/carriere/share/linkedin.svg";

import tel from "../assets/carriere/tel.svg";
import mail from "../assets/carriere/mail.svg";
import link from "../assets/carriere/link.svg";

import specialite from "../assets/carriere/resume/specialite.svg";
import poste from "../assets/carriere/resume/poste.svg";
import niveau from "../assets/carriere/resume/niveau.svg";
import genre from "../assets/carriere/resume/genre.svg";
import hour from "../assets/carriere/resume/hour.svg";
import expérience from "../assets/carriere/resume/experience.svg";
import { Link } from "react-router-dom";
 import axios from 'axios';

const contentStyle = {
    position: "relative",
    background: "linear-gradient(to right, #0c0abe , #07054c)", 
    border: "none",
    width: "100%",
    textAlign: "center",
    padding: "0px !important",
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "80px",
    paddingBottom: "100%"
  
  };

class Carrieres extends React.Component {
    constructor(props) {
        super(props);
    
    this.onChangeRole = this.onChangeRole.bind(this);
    this.onChangePost = this.onChangePost.bind(this);
    this.onChangelocation = this.onChangelocation.bind(this);
    this.onChangedate = this.onChangedate.bind(this);
    this.onChangedescription_Offer = this.onChangedescription_Offer.bind(this);
    this.onChangeCategory = this.onChangeCategory.bind(this);

    this.state = {
        role:'',
        post:'',
        Location:'',
        Date:'',
        Description_Offer:'',
        category:'',
        Id:''
    }
  }

  componentDidMount() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
   

    axios.get(`${process.env.REACT_APP_SERVER}`+'/InternShip_Offer/'+this.props.match.params.id)
      .then(response => {
        this.setState({
            role:response.data.Role,
            post:response.data.Post,
            Date:response.data.date,
            Location:response.data.location,
            Description_Offer:response.data.description_Offer,
            category:response.data.Category.name_Catg,
            Id:response.data._id
        })   
     })
      .catch(function (error) {
        console.log(error);
      })
    }

 
    onChangeRole(e) {
    this.setState({
        role: e.target.value
    })
  }
  
  onChangePost(e) {
    this.setState({
        post: e.target.value
    })
  }
  
  onChangelocation(e) {
    this.setState({
        Location: e.target.value
    })
  }
  onChangeCategory(e) {
    this.setState({
        category: e.target.value
        
    })
  }
  
  
 
  
  onChangedate (date) {
    this.setState({
        Date : date 
    })
  }
  
  onChangedescription_Offer(e) {
    this.setState({
        Description_Offer: e.target.value
    })
  }
  
 
  
  
 
    render() {
        return (
            <div><div className="banniereSlidCarriere">
                {/*Menu horizontal Web*/}
                <div className="menu-horizontal">
                    <Menu />
                </div>
                {/*Menu Responsive Popup*/}
                <div className="menuMobile">
                    <Popup
                        modal
                        overlayStyle={{  background: "linear-gradient(to right, #0c0abe , #07054c)",  width: "100%" }}
                        contentStyle={contentStyle}
                        closeOnDocumentClick={false}
                        trigger={open => <BurgerIcon open={open} />}
                    >
                    <SideList />
                    </Popup>
                </div>

                <div className="textBanniereCarriere">
                 
                        <h1 className="sliderTitleCarriere">REJOIGNEZ<br /><b style={{ color: "#ffd904" }}>NOTRE ÉQUIPE !</b></h1>
                        <div className="imgCarrierebg">
                            <img className="imageBaniereCarriere" src={object_background} alt="" />
                        </div>
                 
                </div>
                </div>
                <div style={{backgroundColor: "white"}}> 
                    
                    <div className="flex-containerDiv" style={{ marginRight:"auto", marginLeft:"auto", marginTop: "15px",marginBottom: "80px"}}>
                        
                        <Grid fluid style={{ paddingRight: "unset", paddingLeft: "unset"}}>
                            <Row className="colwidthdesc">
                            <Col xs={12} md={8} lg={9} className="colwidthdesc"> 
                                    <div className="bgPoste" style={{ marginTop: "40px"}}>
                                       <p className="postTitle">Catégories de Poste : {this.state.category}
                                            {this.onChangeCategory}</p><br/>
                                    </div>
                                    <Grid fluid style={{ paddingRight: "unset", paddingLeft: "unset",display: "flex"}}>
                                                <Row style={{width: "100%"}}>
                                                    <Col xs={3} md={3} lg={2} style={{display: "flex",maxWidth: "100%"}}>
                                                        <ReactSVG src={temps} alt="" />
                                                        <p className="subtitle" style={{color:"#f14e3bbd"}}>Temps plein</p>
                                                    </Col>
                                                    <Col xs={3} md={3} lg={2} style={{display: "flex",maxWidth: "100%"}}>
                                                        <ReactSVG alt="" src={map} />
                                                        <p className="subtitle" style={{color:"#888888"}}> {this.state.Location}
                                              {this.onChangelocation}</p>
                                                    </Col>
                                                    <Col xs={5} md={4} lg={3} style={{display: "flex",maxWidth: "100%"}}>
                                                        <ReactSVG src={calendar} alt="" />
                                                        <p className="subtitle" style={{color:"#888888"}}>{this.state.Date.substring(0,10)}
                                              {this.onChangedate}</p>
                                                    </Col>
                                                    
                                                </Row>
            
                                            </Grid>
                                            <p style={{ marginBottom: "14px", lineHeight: "2"}} className="postTitle">Rôles : <span style={{color:"#888888"}}>{this.state.role} {this.onChangeRole}</span></p>
                                            <div style={{ width: "100%",backgroundColor: "#ccc", height: "1px" }}></div>
                                            <p style={{ marginBottom: "14px", lineHeight: "2"}} className="postTitle">Post : <span style={{color:"#888888"}}>{this.state.post} {this.onChangePost}</span></p>
                                            <p style={{ color: "#000000", marginBottom: "14px", marginTop:"30px"}} className="postTitle">Description du Offer :</p>
                                            <p className="textDetails" >{this.state.Description_Offer}
                                              {this.onChangedescription_Offer}</p>
                                            
                                            
                                           
                                           
                                </Col>
                                
                                
                             
                                <Col xs={12} md={4} lg={3}>
                                    <div style={{textAlign:"center", maxWidth: "100%"}}>
                                        <img alt="" src={logo_chifco} className="logochifco"/>
                                    </div>
                                    <div className="adrContact">
                                        <ReactSVG src={map} alt="" />
                                        <p className="resumetitle" style={{marginLeft: "15px"}}>Technopôle de Sousse, cité Hammam Maarouf, Route ceinture de Sahloul, Sousse 4002</p>                     
                                    </div> <br/>
                                    <div className="adrContact">
                                        <ReactSVG src={link} alt="" />
                                        <p className="resumetitle" style={{marginLeft: "15px"}}>www.chifco.com</p>                     
                                    </div><br/>
                                    <div className="adrContact">
                                        <ReactSVG src={tel} alt="" />
                                        <p className="resumetitle" style={{marginLeft: "15px"}}>+216 73 820 930</p>                     
                                    </div><br/>
                                    <div className="adrContact">
                                        <ReactSVG src={mail} alt="" />
                                        <p className="resumetitle" style={{marginLeft: "15px"}}>chifco@jobsearch.com</p>                     
                                    </div>
                                   {/* <Postuler /> */} 
                                   <Link to={"/postulerStage/"+this.state.Id}> <Button className="PostulerBtn" >
                                        <ReactSVG src={send} alt="" svgStyle={{marginRight:"10px"}} />
                                        Postuler
                                    </Button></Link>
                                    <Link to={"/carrieres"}><Button className="offreBtn"  >
                                       
                                        Voir toutes les offres
                                    </Button></Link>
                                    <div style={{display:"flex", maxWidth: "100%",alignItems: "center",justifyContent: "center"}}>
                                        <p style={{ color: "#000000", marginBottom: "14px"}} className="postTitle" >Share</p>
                                      
                                        <ReactSVG src={facebook} alt="" svgStyle={{marginLeft:"20px"}}/>
                                        <ReactSVG src={twitter} alt="" svgStyle={{marginLeft:"20px"}}/>
                                        <ReactSVG src={linkedin} alt="" svgStyle={{marginLeft:"20px"}}/>
                                       
                                    </div>
                                </Col> 
                                   
                            </Row>
                        </Grid>
                    </div>
                   
                </div>
               
                <MapAddresse />
                <NewsLetter />
                <Footer />
            </div>
        );
    }
}
export default Carrieres;



// WEBPACK FOOTER //
// ./src/pages/internshipDescription.js